import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { WorkflowConfigurationExport } from "@idw-types/data/workflow-configuration-export";
import { QueryParameter } from "@idw-types/common";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

export const exportWorkflowConfigurationRequest = async (
    workflowId: string
): Promise<GenericNetworkResponse<WorkflowConfigurationExport>> => {
    const queryParameters: Array<QueryParameter> = [
        { parameter: "workflowID", value: workflowId }
    ];

    const { data, error } = await handleRequestWithQueryParams(
        RequestTypes.GET,
        apiRoutes.serviceConfiguration.workflow.export,
        queryParameters
    );
    return { data, error, queryParameters };
};